module.exports = __webpack_public_path__ + "img/logo-101-white.28fb784d.png";